module.exports = __webpack_public_path__ + "img/health.bac8a998.png";